import Header from "@/components/Header";
import Hero from "@/components/Hero";
import EventDescription from "@/components/EventDescription";
import WhatToExpect from "@/components/WhatToExpect";
import AboutHosts from "@/components/AboutHosts";
import RetreatPreview from "@/components/RetreatPreview";
import RegistrationForm from "@/components/RegistrationForm";
import Footer from "@/components/Footer";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="landing-page">
      <Header />
      <Hero />
      <EventDescription />
      <WhatToExpect />
      <AboutHosts />
      <RetreatPreview />
      <RegistrationForm />
      <Footer />
    </div>
  );
}
